import { DialogHeader, pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Wrapper = styled.div `
  width: 100%;
  overflow: auto;

  max-height: ${pxToRem(800)};
  transition: max-height 0.2s ease-in-out;
`;
export const StyledDialogHeader = styled(DialogHeader) `
  border-bottom: ${pxToRem(1)} solid ${themeGet('colors.border.100')};
  padding: ${themeGet('spacing.md')} 0;
`;
